import React, { memo } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Start from '../Start';
import Contact from '../Contact';
import Portfolio from '../Portfolio';

const Routers = memo(() => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Start />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </BrowserRouter>
  );
});

export default Routers;